/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { defineMessages, useIntl } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import FOPIframe from "../../FOPIframe";

/* Styles */
import styles from "./styles";

const CardModal = ({showModal, setShowModal, paymentToken, modalTitle, callback, modalSubtitle}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      className={ classes.modal }
      showModal={ showModal }
      setShowModal={ setShowModal }
      modalHeaderTitle= {modalTitle}
      modalHeaderSubtitle= {modalSubtitle}
      modalContent={<FOPIframe setShowModal={setShowModal} callback={callback} paymentToken={paymentToken}/>}
      dataTestId="CardModal"
      size="md"
    />
  )
}

export default CardModal;